export function getCategoryName(name: string) {
    const [firstHalf, secondHalf] = name.split('/');
    return secondHalf ? secondHalf : firstHalf;
}
